<template>
  <div class="loader-container">
       <img src="@/assets/images/loader-black.gif" alt="#">
  </div>
</template>

<script>
export default {
    name: "PageLoader"
}
</script>

<style lang="scss">
    body {
        // overflow: hidden;
    }
</style>

<style lang="scss" scoped>
    .loader-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
        background: rgba(0,0,0,0.5);
        backdrop-filter: blur(3px);
        z-index: 1080;
    }
</style>